/* eslint-disable no-mixed-operators */
// @flow

import React from 'react';
import styled from 'styled-components';
import Link from 'react-router-dom/Link';
import some from 'lodash/some';
import { Motion, spring } from 'react-motion';

import Bracket from './Bracket';

import { colors } from '../style';

function getLeft(props) {
  if (props.isChild || props.direction === 'left') {
    return 'auto';
  }

  return '0';
}

function getRight(props) {
  if (props.isChild || props.direction === 'left') {
    return '0';
  }

  return 'auto';
}

function getTranslateX(props) {
  if (props.isChild) {
    return (props.direction === 'left' ? -1 : 1) * 100;
  }

  return 0;
}

const Root = styled.div`
  position: absolute;
  left: ${getLeft};
  right: ${getRight};
  top: 50%;

  margin-top: ${props => props.align === 'center' ? 0 : 15}px;

  display: flex;
  flex-direction: column;
  padding-left: ${props => props.direction === 'left' ? 0 : 42}px;
  padding-right: ${props => props.direction === 'left' ? 42 : 0}px;
`

const Category = styled.div`
  position: relative;
  padding-right: 15px;
`

const CategoryName = styled(({ selected, selectedColor, children, ...rest }) => <Link {...rest}>{children}</Link>)`
  border: none;

  text-align: left;
  text-decoration: none;
  white-space: nowrap;

  font-family: 'PF DIN', Helvetica, Arial, sans-serif;
  font-weight: 300;
  font-size: 21px;
  font-style: ${props => props.selected ? 'italic' : 'normal'};
  line-height: 1;

  background: transparent;
  color: ${props => props.selected ? props.selectedColor : props.color};
  outline: none;

  cursor: ${props => props.selected ? 'default' : 'pointer'};
`

function isSelected(id: number, selectedId: ?number, categories: Array<Object>) {
  if (id === selectedId) return true;

  return some(categories, cat => cat.parentId === id && isSelected(cat.id, selectedId, categories))
}

type Props = {
  direction: string,
  categories: Array<Object>,
  selectedId: ?number,
  parentId?: number,
  color: string,
}

function CategoryGroup({ direction, categories, parentId, selectedId, color }: Props) {
  const filteredCategories = parentId
    ? categories.filter(cat => cat.parentId === parentId)
    : categories.filter(cat => !cat.parentId);
  const parent = parentId ? categories.find(cat => cat.id === parentId) : null;
  const nextTranslateX = getTranslateX({
    isChild: typeof parentId === 'number',
    direction
  });

  return (
    <Motion
      defaultStyle={{
        opacity: 0,
        translateX: nextTranslateX > 0 ? 72 : 0,
      }}
      style={{
        opacity: spring(1, {stiffness: 120, damping: 14}),
        translateX: spring(nextTranslateX, {stiffness: 221, damping: 31}),
      }}
    >
      {interpolated => (
        <Root
          isChild={typeof parentId === 'number'}
          direction={direction}
          align={filteredCategories.length % 2 === 0 ? 'bottom' : 'center'}
          style={{
            opacity: interpolated.opacity,
            transform: `translate(${interpolated.translateX}%, -50%)`,
          }}
        >
          <Bracket
            color={color}
            direction={direction}
            nodeCount={filteredCategories.length}
          />
          {filteredCategories.map((cat, index) => (
            <Category key={index}>
              <CategoryName
                selected={Boolean(selectedId) && isSelected(cat.id, selectedId, categories)}
                color={color}
                selectedColor={cat.color || parent && parent.color || colors.darkGrey}
                to={`/${cat.contentType}/${cat.id}`}
              >
                {cat.title}
              </CategoryName>
              {Boolean(selectedId) && isSelected(cat.id, selectedId, categories) ? (
                <CategoryGroup
                  categories={categories}
                  parentId={cat.id}
                  selectedId={selectedId}
                  direction={direction}
                  color={cat.color || parent && parent.color || colors.darkGrey}
                />
              ) : null}
            </Category>
          ))}
        </Root>
      )}
    </Motion>
  )
}

export default CategoryGroup;



// WEBPACK FOOTER //
// ./src/components/CategoryNav/CategoryGroup.js